import type { ReactElement, ReactNode } from 'react'
import styles from './Overlay.module.css'

// layering: surface, hairline line, r2; overlay-sm transient, overlay-lg
// interrupting; a panel header strip; a footer strip only where content
// scrolls beneath actions; one scrim.

// eslint-disable-next-line react-refresh/only-export-components -- the wrappers put these classes on Base UI parts, as the brief specifies
export const overlayClass = {
  surface: styles.surface,
  scrim: styles.scrim,
  title: styles.title,
}

/** `title` is a Base UI `Title` (h2) with `overlayClass.title`; `close` a Base UI `Close` rendering an `IconButton`. */
export function OverlayHeader({
  title,
  close,
}: {
  title: ReactElement
  close?: ReactElement
}) {
  return (
    <div className={styles.header}>
      {title}
      {close}
    </div>
  )
}

export function OverlayFooter({ children }: { children: ReactNode }) {
  return <div className={styles.footer}>{children}</div>
}
